import { colors, space, fontSize } from "../../design/tokens";

export default function Checkbox({
  label,
  checked,
  onChange,
  style
}) {
  return (
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: space.sm,
        color: colors.text,
        fontSize: fontSize.sm,
        cursor: "pointer",
        ...style,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          width: "16px",
          height: "16px",
          accentColor: colors.primary,
          cursor: "pointer",
        }}
      />

      {label}
    </label>
  );
}